module.exports = __webpack_public_path__ + "img/front_water_bump.3771f7c4.jpg";